import Vue from 'vue'
import Select2 from 'v-select2-component';

Vue.component('Select2', Select2);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/select2.js